module.exports = __webpack_public_path__ + "img/noProfilePicture.c14d9335.png";